import { Component, OnInit, Injectable } from '@angular/core';
/* SERVICES */
import { HttpClientEnersolService } from 'src/services/http-client-enersol.service';
import { GlobalService } from 'src/services/global';
import { ConstantsService } from 'src/services/constants.service';
import { ValidationsService } from 'src/services/validations.service';
/* REST MODEL */
import { ListResponse } from 'src/models/com.enersol.directshopping.ws.rest.model/ListResponse';
import { Response } from 'src/models/com.enersol.directshopping.ws.rest.model/Response';
/* MODELS */
import { ProductoPresentacion } from 'src/models/com.enersol.directshopping.dal.entidad/ProductoPresentacion';
import { Familia } from 'src/models/com.enersol.directshopping.dal.entidad/Familia';
import { ProductoPorOrdenDeCompra } from 'src/models/com.enersol.directshopping.dal.entidad/ProductoPorOrdenDeCompra';
import { ProductoSugerido } from 'src/models/com.enersol.directshopping.dal.entidad/ProductoSugerido';
import { Parametro } from 'src/models/com.enersol.directshopping.dal.entidad/Parametro';
import { Marca } from 'src/models/com.enersol.directshopping.dal.entidad/Marca';


@Injectable()
export class PrincipalController {

  urlEnersol: string = "";

  constructor(
    private httpClientEnersolService: HttpClientEnersolService,
    private globalEnersolService: GlobalService,
    private constantsEnersolService: ConstantsService,
    private validationsEnersolService: ValidationsService
  ) {
    this.urlEnersol = this.constantsEnersolService.getUrlEnersol();
  }

  /* FUNCIONES QUE HACEN PETICIONES A LOS SERVICIOS */

  /**
  * Función obtiene los productos sugeridos a mostrar
  * @returns ListResponse<ProductoPresentacion>
  * @author msemeraro
  */
  async getProductosSugeridos(): Promise<ListResponse<ProductoSugerido>> {
    let respuesta: ListResponse<ProductoSugerido>;
    try {
      let promiseResponse = await this.httpClientEnersolService.httpGet<ListResponse<ProductoSugerido>>('ProductoPorOrdenDeCompra/Sugeridos');
      respuesta = <ListResponse<ProductoSugerido>>promiseResponse;
    }
    catch (error) {
      console.log(error.message);
      respuesta = new ListResponse<ProductoSugerido>(false);
      respuesta.addError('code', 'techMessage', 'userMessage');
    }
    finally {
      for (let producto of respuesta.data) {
        producto.cantidad = Math.round(producto[1]);
        producto.productoPresentacion = producto[0];
      }
      return respuesta;
    }
  }


  /**
  * Función obtiene los productos nuevos a mostrar
  * @returns ListResponse<ProductoPresentacion>
  * @author msemeraro
  */
  async getProductosNuevos(): Promise<ListResponse<ProductoPresentacion>> {
    let respuesta: ListResponse<ProductoPresentacion>;
    try {
      let promiseResponse = await this.httpClientEnersolService.httpGet<ListResponse<ProductoPresentacion>>('ProductoPresentacion/nuevos');
      respuesta = <ListResponse<ProductoPresentacion>>promiseResponse;
    }
    catch (error) {
      console.log(error.message);
      respuesta = new ListResponse<ProductoPresentacion>(false);
      respuesta.addError('code', 'techMessage', 'userMessage');
    }
    finally {
      return respuesta;
    }
  }

  /**
  * Función obtiene los productos en promocion a mostrar
  * @returns ListResponse<ProductoPresentacion>
  * @author msemeraro
  */
  async getProductosPromociones(): Promise<ListResponse<ProductoPresentacion>> {
    let respuesta: ListResponse<ProductoPresentacion>;
    try {
      let promiseResponse = await this.httpClientEnersolService.httpGet<ListResponse<ProductoPresentacion>>('ProductoPresentacion/promociones');
      respuesta = <ListResponse<ProductoPresentacion>>promiseResponse;
    }
    catch (error) {
      console.log(error.message);
      respuesta = new ListResponse<ProductoPresentacion>(false);
      respuesta.addError('code', 'techMessage', 'userMessage');
    }
    finally {
      return respuesta;
    }
  }

  /**
  * Función obtiene las familias registradas
  * @returns ListResponse<Familia>
  * @author msemeraro
  */
  async getFamilias(): Promise<ListResponse<Familia>> {
    let respuesta: ListResponse<Familia>;
    try {
      let promiseResponse = await this.httpClientEnersolService.httpGet<ListResponse<Familia>>('Familia/all');
      respuesta = <ListResponse<Familia>>promiseResponse;
    }
    catch (error) {
      console.log(error.message);
      respuesta = new ListResponse<Familia>(false);
      respuesta.addError('code', 'techMessage', 'userMessage');
    }
    finally {
      return respuesta;
    }
  }

  /**
  * Función obtiene los productos de una familia
  * @param codFamilia codigo de la familia de los productos a mostrar
  * @returns ListResponse<ProductoPresentacion>
  * @author msemeraro
  */
  async getProductosFamilia(codFamilia: number): Promise<ListResponse<ProductoPresentacion>> {
    let respuesta: ListResponse<ProductoPresentacion>;
    try {
      let promiseResponse = await this.httpClientEnersolService.httpGet<ListResponse<ProductoPresentacion>>('ProductoPresentacion/familia?codFamilia=' + codFamilia);
      respuesta = <ListResponse<ProductoPresentacion>>promiseResponse;
    }
    catch (error) {
      console.log(error.message);
      respuesta = new ListResponse<ProductoPresentacion>(false);
      respuesta.addError('code', 'techMessage', 'userMessage');
    }
    finally {
      return respuesta;
    }
  }


  /* FUNCIONES QUE HACEN PETICIONES AL GLOBAL SERVICE */

  /**
    * Función que obtiene el tipo de cambio
    * @return tipoCambio 
    * @author msemeraro
    */
   async getTipoCambio() {
    await this.globalEnersolService.setTipoCambio();
    let tipoCambio: Parametro = this.globalEnersolService.getTipoCambio();
    return Number(tipoCambio.valor); 
  }

  /**
  * Función que actualiza los datos en el globalService para mostrar un listado de productos
  * @param nombreLista nombre de la lista de productos
  * @param codigo codigo de la familia de productos
  * @param titulo titulo de la lista de productos
  * @author msemeraro
  */
  verListadoProductos(nombreLista: string, codigo: number, titulo: string) {
    this.globalEnersolService.setCodigoFamiliaProductos(codigo);
    this.globalEnersolService.setNombreListaProductos(nombreLista);
    this.globalEnersolService.setNombreProductos(titulo);
  }

  /**
  * Función que almacena en el globalService los datos del producto a mostrar
  * @param producto producto a visualizar
  * @author msemeraro
  */
  verDetalleProducto(producto: ProductoPresentacion, cantidad: number) {
    this.globalEnersolService.setCodProductoSeleccionado(producto.id.codigoProducto);
    this.globalEnersolService.setCodProductoPresentacionSeleccionado(producto.id.codigoProductoPresentacion);
    this.globalEnersolService.setCodPresentacionProductoSeleccionado(producto.id.codigoPresentacion);
    this.globalEnersolService.setCodMarcaProductoSeleccionado(producto.id.codigoMarca);
    this.globalEnersolService.setCantidadProductoSeleccionado(cantidad);
  }

  /**
  * Función que añade un producto a una orden de compra
  * @param producto producto a insertar
  * @param cantidad cantidad de unidades del producto que se quieren insertar
  * @returns Response<ProductoPorOrdenDeCompra>
  * @author msemeraro
  */
  async addCarrito(producto: ProductoPresentacion, cantidad: number): Promise<Response<ProductoPorOrdenDeCompra>> {
    return this.globalEnersolService.addCarrito(producto, cantidad);
  }

  /**
  * Función que guarda las variables para mostrar un mensaje
  * @param tituloMensaje
  * @param contenidoMensaje
  * @param esError
  * @author msemeraro
  */
  setMensaje(tituloMensaje: String, contenidoMensaje: String, esError: Boolean): void {
    this.globalEnersolService.setTituloMensaje(tituloMensaje);
    this.globalEnersolService.setContenidoMensaje(contenidoMensaje);
    this.globalEnersolService.setEsError(esError);
  }

  /**
  * Función que obtiene el titulo de un mensaje
  * @return tituloMensaje 
  * @author msemeraro
  */
  getTituloMensaje(): String {
    return this.globalEnersolService.getTituloMensaje();
  }

  /**
  * Función que obtiene el contenido de un mensaje
  * @return contenidoMensaje 
  * @author msemeraro
  */
  getContenidoMensaje(): String {
    return this.globalEnersolService.getContenidoMensaje();
  }

  /**
  * Función que obtiene si un mensaje es error o no
  * @return esError 
  * @author msemeraro
  */
  getEsError(): Boolean {
    return this.globalEnersolService.getEsError();
  }


  /* OTRAS FUNCIONES */

  /**
  * Función que formatea un número
  * @param numero
  * @returns number formateado
  * @author msemeraro
  */
  getFormatNumber(numero: number) {
    return this.validationsEnersolService.getNumber(numero);
  }

    /**
   * Funcion que realiza una solicitud al servidor y obtiene una lista de marcas
   * @param url : Direccion a consultar
   */
  async getMarcas() {
    let respuesta: ListResponse<Marca>;
    try {
      const promiseResponse = await this.httpClientEnersolService.httpGet<ListResponse<Marca>>('Marca/all');
      respuesta = promiseResponse as ListResponse<Marca>;
    } catch (error) {
      console.log(error.message);
      respuesta = new ListResponse<Marca>(false);
      respuesta.addError('code', 'techMessage', 'userMessage');
    } finally {
      return respuesta;
    }
  }
}
